import React from 'react';
import { Link } from 'react-router-dom';
import LogoImg from '../img/logo.svg';
import BackgroundImage from '../img/hero-bg.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone, faEnvelope, faPaperPlane } from '@fortawesome/free-solid-svg-icons';

const Footer = () => {
  return (
    <div className="footer-container" style={{ backgroundImage: `url(${BackgroundImage})` }}>
      <div className="footer-overlay">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img src={LogoImg} alt="Logo" />
            </div>
            <p>Престижная ежегодная международная премия, учрежденная Некоммерческим Партнерством Разработчиков Программного обеспечения «РУССОФТ».</p>
          </div>
          <div className="footer-section">
            <h4>О премии</h4>
            <ul>
              <li><Link to="/">Главная</Link></li>
              <li><Link to="/winners">Победители</Link></li>
              <li><Link to="/jury">Жюри</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Информация</h4>
            <ul>
              <li><Link to="/documents">Документы</Link></li>
              <li><Link to="/team">Статьи</Link></li>
              <li><Link to="/contacts">Контакты</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Контакты</h4>
            <p><FontAwesomeIcon icon={faMapMarkerAlt} /> Биржевая линия, д. 16, оф. 411, Санкт-Петербург, 199034 </p>
            <p><FontAwesomeIcon icon={faPhone} /> +7 (812) 480-05-05</p>
            <p className='mb-20'><FontAwesomeIcon icon={faEnvelope} />info@russoft.org</p>
            <h4>Подписаться</h4>
            <p>Не упустите возможность подписаться на наши новости</p>
            <form className="newsletter-form">
              <input type="email" placeholder="Email" />
              <button type="submit"><FontAwesomeIcon icon={faPaperPlane} /></button>
            </form>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2019 International IT Leaders Award. Все права защищены.</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;